import stdempLabels from 'assets/labels/stdemp'

export const mocker = {
  labels () {
    return {
      labels: stdempLabels
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/stdemp/mocker.js